import { DomainsActions, DomainsState } from '../types';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialDomainsState } from '.';
import { addNewDomainAsync } from '../actions';
import { DomainItem } from '@anm/api/modules/customDomains';

const addNewDomainReducer: Reducer<DomainsState, DomainsActions> = (state = initialDomainsState, action) => {
  switch (action.type) {
    case getType(addNewDomainAsync.request): {
      return {
        ...state,
        addNewDomain: {
          ...state.addNewDomain,
          isPending: true,
          params: {
            domain: action.payload
          }
        }
      };
    }
    case getType(addNewDomainAsync.success): {
      const newDomain: DomainItem = {
        Host: state.addNewDomain.params.domain,
        Timestamp: '',
        UserId: '',
        ValidTo: '',
        State: 'OK'
      };

      return {
        ...state,
        list: [...(state.list || []), newDomain],
        addNewDomain: {
          ...state.addNewDomain,
          isPending: false
        }
      };
    }
    case getType(addNewDomainAsync.failure): {
      return {
        ...state,
        addNewDomain: {
          ...state.addNewDomain,
          isPending: false,
          isError: true,
          error: action.payload
        }
      };
    }

    default:
      return state;
  }
};

export default addNewDomainReducer;
